import {
  useAuth as _useClerkAuth,
  useUser as _useClerkUser,
} from "@clerk/clerk-react";

const DEV_BYPASS = import.meta.env["VITE_DEV_AUTH_BYPASS"] === "true";

const devAuthReturn = {
  isLoaded: true as const,
  isSignedIn: true as const,
  userId: "dev-user-id",
  getToken: async (_opts?: unknown): Promise<string | null> =>
    "dev-bypass-token",
  signOut: async () => {},
};

// NOTE: This mock covers only the fields used in this codebase. Callers using
// additional Clerk user fields (e.g. publicMetadata, externalAccounts) will get undefined.
const devUserReturn = {
  isLoaded: true as const,
  isSignedIn: true as const,
  user: {
    id: "dev-user-id",
    fullName: "Dev User",
    firstName: "Dev",
    lastName: "User",
    emailAddresses: [{ emailAddress: "dev@local.dev" }],
    primaryEmailAddress: { emailAddress: "dev@local.dev" },
    imageUrl: "",
  },
};

export const useAuth = DEV_BYPASS
  ? function useAuth() {
      return devAuthReturn;
    }
  : _useClerkAuth;

export const useUser = DEV_BYPASS
  ? function useUser() {
      return devUserReturn;
    }
  : _useClerkUser;
